export const featuredCourse = {
  id: 'curso-completo-ia',
  title: 'Curso Completo: ChatGPT e Gemini para Professores',
  description: 'Aprenda a usar IA de forma prática e intencional no seu dia a dia escolar. Metodologia comprovada com materiais prontos, e-books e suporte completo.',
  badge: 'MAIS VENDIDO',
  image: 'https://public.readdy.ai/ai/img_res/7ea2d4b80218e440735237e45e7c3685.jpg',
  price: 'R$ 147,00',
  features: [
    'Acesso vitalício ao conteúdo',
    'Materiais prontos em Word e PDF',
    '2 e-books práticos inclusos',
    'Suporte via WhatsApp',
    'Certificado de conclusão',
    'Garantia de 15 dias'
  ]
};

export const centralPedagogica = {
  id: 'central-pedagogica',
  title: 'Central Pedagógica',
  subtitle: 'Seu hub completo de recursos educacionais com IA',
  description: 'Biblioteca viva de planos de aula, atividades, projetos interdisciplinares, avaliações e materiais prontos para usar — tudo gerado e organizado com inteligência artificial, alinhado à BNCC.',
  badge: 'BÔNUS #1 — EXCLUSIVO',
  badgeColor: 'from-emerald-500 to-teal-600',
  image: 'https://readdy.ai/api/search-image?query=modern%20digital%20library%20hub%20platform%20organized%20colorful%20educational%20resources%20lesson%20plans%20activities%20assessments%20books%20documents%20folders%20on%20clean%20white%20background%20technology%20interface%20grid%20layout%20professional%20flat%20design%20bright%20fresh%20colors%20green%20teal%20accent&width=800&height=600&seq=central001&orientation=landscape',
  features: [
    'Planos de aula prontos por disciplina e faixa etária',
    'Banco de atividades alinhadas à BNCC',
    'Projetos interdisciplinares prontos para aplicar',
    'Modelos de avaliação diagnóstica e formativa',
    'Comunicados e relatórios para famílias',
    'Atualização contínua de conteúdo'
  ],
  icon: 'ri-building-2-line'
};

export const bonusAgents = [
  {
    id: 'agente-infantil',
    title: 'Agente IA — Educação Infantil',
    description: 'Assistente especializado para professores da educação infantil, com prompts e recursos adaptados para essa faixa etária. Gera atividades lúdicas, rotinas pedagógicas e comunicados em segundos.',
    badge: 'BÔNUS #2',
    image: 'https://readdy.ai/api/search-image?query=colorful%20playful%20isometric%20illustration%20artificial%20intelligence%20assistant%20early%20childhood%20education%20with%20toys%20books%20abc%20blocks%20crayons%20happy%20children%20elements%20soft%20pastel%20colors%20clean%20white%20background%20modern%203d%20style&width=600&height=600&seq=agent001&orientation=squarish',
    icon: 'ri-bear-smile-line',
    capabilities: [
      'Rotinas pedagógicas semanais',
      'Atividades lúdicas por tema',
      'Relatórios de desenvolvimento infantil',
      'Comunicados para responsáveis',
      'Sequências didáticas BNCC',
      'Sugestões de brincadeiras educativas'
    ]
  },
  {
    id: 'agente-fundamental',
    title: 'Agente IA — Ensino Fundamental',
    description: 'Assistente especializado para professores do ensino fundamental, com ferramentas para planejamento, avaliação e diferenciação pedagógica. Economize horas de trabalho toda semana.',
    badge: 'BÔNUS #3',
    image: 'https://readdy.ai/api/search-image?query=modern%20isometric%20illustration%20artificial%20intelligence%20assistant%20elementary%20school%20education%20with%20books%20notebooks%20pencils%20globe%20science%20elements%20academic%20items%20vibrant%20professional%20colors%20clean%20white%20background%203d%20style&width=600&height=600&seq=agent002&orientation=squarish',
    icon: 'ri-book-open-line',
    capabilities: [
      'Planos de aula por disciplina',
      'Avaliações diagnósticas e formativas',
      'Projetos interdisciplinares',
      'Atividades diferenciadas por nível',
      'Feedback individualizado ao aluno',
      'Diários de classe e registros'
    ]
  },
  {
    id: 'agente-documentacao',
    title: 'Agente IA — Especialista em Documentação Pedagógica',
    description: 'Agente criado para apoiar professores da educação básica na construção de documentos pedagógicos da educação especial de forma clara, ética, prática e alinhada à legislação educacional brasileira.',
    badge: 'BÔNUS #4',
    image: 'https://readdy.ai/api/search-image?query=professional%20isometric%20illustration%20artificial%20intelligence%20assistant%20specialized%20in%20special%20education%20documentation%20legal%20papers%20reports%20organized%20files%20folder%20checklist%20clipboard%20inclusive%20education%20symbols%20clean%20modern%20flat%20design%20teal%20green%20accent%20colors%20white%20background%203d%20style&width=600&height=600&seq=agent003&orientation=squarish',
    icon: 'ri-file-text-line',
    capabilities: [
      'PDI — Plano de Desenvolvimento Individual',
      'Relatórios de AEE (Atendimento Educacional Especializado)',
      'Laudos pedagógicos adaptados',
      'Planos de ensino individualizados',
      'Adequações curriculares por necessidade',
      'Documentação alinhada à LBI e LDBEN',
      'Pareceres descritivos de inclusão',
      'Registros de acompanhamento terapêutico'
    ]
  }
];

export const allCourses = [
  {
    id: 'formacao-continuada',
    title: 'Formação Continuada em IA',
    description: 'Programa completo de desenvolvimento profissional para educadores que desejam dominar o uso de IA na educação.',
    duration: '40 horas',
    level: 'Intermediário',
    image: 'https://readdy.ai/api/search-image?query=professional%20teachers%20attending%20modern%20technology%20training%20workshop%20classroom%20setting%20laptops%20screens%20showing%20ai%20interfaces%20collaborative%20learning%20environment%20bright%20natural%20lighting%20clean%20minimalist%20background&width=800&height=600&seq=course002&orientation=landscape'
  },
  {
    id: 'metodologias-ativas',
    title: 'Metodologias Ativas com IA',
    description: 'Aprenda a integrar metodologias ativas de ensino com ferramentas de inteligência artificial para engajar seus alunos.',
    duration: '30 horas',
    level: 'Básico',
    image: 'https://readdy.ai/api/search-image?query=dynamic%20interactive%20classroom%20scene%20students%20engaged%20active%20learning%20teacher%20facilitating%20with%20technology%20tablets%20collaborative%20work%20modern%20educational%20environment%20bright%20colors%20clean%20background&width=800&height=600&seq=course003&orientation=landscape'
  },
  {
    id: 'avaliacao-ia',
    title: 'Avaliação e Feedback com IA',
    description: 'Otimize seu processo de avaliação e forneça feedback personalizado usando inteligência artificial.',
    duration: '20 horas',
    level: 'Intermediário',
    image: 'https://readdy.ai/api/search-image?query=teacher%20reviewing%20student%20work%20digital%20tablet%20showing%20assessment%20feedback%20interface%20modern%20desk%20organized%20workspace%20professional%20educational%20setting%20soft%20natural%20lighting%20clean%20minimalist%20background&width=800&height=600&seq=course004&orientation=landscape'
  }
];